
import Vue from 'vue'
import moment from 'moment'
import {Component, Prop} from "vue-property-decorator";
import {GET_MODE} from "@/store/getter-types";

@Component({
  components: {}
})
export default class CalendarWeekSelector extends Vue {
  @Prop({type: String, required: true}) isoWeek!: string
  @Prop({type: Boolean, default: true}) allowNavigationToPast!: boolean
  @Prop({type: Date}) date!: Date

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get weekLabel (): string {
    const locale =localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
    return `${moment(this.isoWeek).locale(locale).format('W')}. ${this.$t('orderPage.weekName')}`
  }

  get dateYear (): string {
    return moment(this.date).format('Y')
  }

  get weekRange (): string {
    const start = moment(this.isoWeek)
    const end = start.clone().add(1, 'week')

    return `${start.format('D.M')} - ${end.format('D.M')}`
  }

  get isBackButtonEnabled (): boolean {
    if (this.allowNavigationToPast) {
      return true
    } else {
      const currentWeekStart = moment().startOf('isoWeek')
      const previousWeekStart = moment(this.isoWeek).subtract(1, 'week').startOf('isoWeek')

      return !previousWeekStart.isBefore(currentWeekStart)
    }
  }

  get showLargeButton (): boolean {
    return !this.$vuetify.breakpoint.xs
  }

  onNextButtonClick (): void {
    this.$emit('update:isoWeek', moment(this.isoWeek).add(1, 'week').format('GGGG[W]WW'))
  }

  onPrevButtonClick (): void {
    this.$emit('update:isoWeek', moment(this.isoWeek).subtract(1, 'week').format('GGGG[W]WW'))
  }
}
